import * as React from "react";

import { footerLinks } from "@/config/site";
import { Link } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import * as m from "@/paraglide/messages";

import LogoText from "../global/LogoText";
import { Button } from "../ui/button";

export function SiteFooter({ className }: React.HTMLAttributes<HTMLElement>) {
  return (
    <footer className={cn("border-t", className)}>
      <div className="container grid max-w-6xl grid-cols-1 gap-6 py-14 sm:grid-cols-2 md:grid-cols-5">
        <div>
          <LogoText className="h-8" />
        </div>
        {footerLinks.map((section) => (
          <div key={section.title}>
            <span className="text-sm font-medium text-foreground">
              {section.title}
            </span>
            <ul className="mt-4 list-inside space-y-3">
              {section.items?.map((link) => (
                <li key={link.title}>
                  <Link
                    href={link.href}
                    className="capitalize text-sm text-muted-foreground hover:text-primary"
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t py-4">
        <div className="container flex flex-col md:flex-row max-w-6xl items-center justify-between">
          <span className="text-sm text-muted-foreground">
            Copyright &copy; 2024. {m.all_right_reserved()}.
          </span>

          <div className="flex items-center gap-3">
            <Button
              variant={"link"}
              className="capitalize text-muted-foreground font-medium text-xs"
            >
              <Link href="mailto:contact@arya.com">{m.support()}</Link>
            </Button>
            <Button
              variant={"link"}
              className="capitalize text-muted-foreground font-medium text-xs"
            >
              <Link href="/privacy">{m.privacy()}</Link>
            </Button>
            <Button
              variant={"link"}
              className="capitalize text-muted-foreground font-medium text-xs"
            >
              <Link href="/terms">{m.terms()}</Link>
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
}
